import "./empty.css";
import { Empty } from './empty';
export default Empty;